
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-6">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="createAccount">
              <h2>Criação de Caixa</h2>
              <div class="space-25"></div>

              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  placeholder="28-09"
                  class="form-control"
                  v-model="form.name"
                />
              </div>

              <div class="form-group">
                <label>Total de vendas no sistema</label>
                <input
                  disabled
                  type="Number"
                  placeholder="0"
                  class="form-control"
                  v-model="form.totalSystemSales"
                />
              </div>
              <div class="form-group">
                <label>Labels</label>
                <tags-input
                  :tags="labelsForDisplay"
                  placeholder="Insira uma label"
                  :select="true"
                  :select-items="availableLabels"
                  @on-select="addLabel"
                  @on-tags-changed="syncLabels"
                >
                  <template #select-item="slotProps">
                    {{ slotProps.value }}
                  </template>
                </tags-input>
              </div>

              <h3>Links atuais</h3>
              <ActualLinked v-model="existenteLinkedAccounting" />

              <h3>Movimentos</h3>
              <Movements v-model="form.movements" :showForm="true" /><br />
              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                :disabled="!permissionCreate || control.createButtonIsDisabled"
                v-if="!control.editModeId"
              >
                <i class="fa fa-save"></i>
                Abrir caixa
              </button>

              <div v-if="control.editModeId">
                <button
                  class="btn btn-outline"
                  href="mail_compose.html"
                  :disabled="control.createButtonIsDisabled"
                  @click="disableEditMode"
                >
                  Cancelar
                </button>

                <button
                  class="btn btn-warning pull-right"
                  href="mail_compose.html"
                  :disabled="
                    control.createButtonIsDisabled || !permissionUpdate
                  "
                  @click="saveEdition"
                >
                  <i class="fa fa-save"></i>
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
        <OpenedAccounting
          @edit-mode="enterEditMode"
          :existentLabels="existentLabels"
          ref="OpenedRef"
        />
      </div>

      <ClosedAccounting
        @set-linked="v => (form.linkedAccountingCash = v)"
        :existentLabels="existentLabels"
        ref="ClosedRef"
      />
    </div>
  </div>
</template>

<script>
import Movements from '../../components/movements/Movments';
import ClosedAccounting from './components/closed-accounting/ClosedAccounting';
import OpenedAccounting from './components/opened-accounting-cash/OpenedAccounting';
import ActualLinked from './components/actual-linked/ActualLinked';
import { toast } from '@/plugins/toast';

export default {
  name: 'RegisterZones',
  components: {
    Movements,
    ClosedAccounting,
    OpenedAccounting,
    ActualLinked,
  },

  data() {
    return {
      existentLabels: [],
      existenteLinkedAccounting: [],
      form: {
        name: '',
        totalSystemSales: '',
        labels: [],
        movements: [],
        linkedAccountingCash: [],
      },

      control: {
        editModeId: false,
        createButtonIsDisabled: false,
        roleList: [],
      },
    };
  },

  computed: {
    labelsForDisplay() {
      return this.form.labels.map((l) => l.value);
    },
    availableLabels() {
      const selectedKeys = this.form.labels.map((l) => l.key);
      return this.existentLabels.filter((l) => !selectedKeys.includes(l.key));
    },
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'manager-accounting-cash',
        'CREATE',
      );
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'manager-accounting-cash',
        'READ',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'manager-accounting-cash',
        'UPDATE',
      );
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'manager-accounting-cash',
        'DELETE',
      );
    },
  },
  mounted() {
    this.loadLabels();
  },
  watch: {
    'form.linkedAccountingCash'() {
      const { totalSystemSales } = this.concatLinked();
      this.form.totalSystemSales = (totalSystemSales / 100).toFixed(2);
    },
  },

  methods: {
    addLabel(item) {
      if (!this.form.labels.find((l) => l.key === item.key)) {
        this.form.labels.push(item);
      }
    },
    syncLabels(tags) {
      this.form.labels = this.existentLabels.filter((l) =>
        tags.includes(l.value),
      );
    },
    async loadLabels() {
      const labels = await this.$store.dispatch('LABELS/All');
      const formattedLabels = labels.map(label => {
        return {
          key: label._id,
          value: label.title,
        };
      });
      this.existentLabels = formattedLabels;
    },
    async createAccount() {
      if (!this.permissionCreate) {
        return;
      }
      if (this.form.name.length === 0) {
        return;
      }

      const totalSystemSales = this.form.linkedAccountingCash.reduce(
        (acc, account) => acc + account.totalSystemSales,
        0,
      );

      const formattedLinkedAccountingCash = this.form.linkedAccountingCash.map(
        account => account._id,
      );

      this.control.createButtonIsDisabled = true;
      const payload = {
        totalSystemSales,
        labels: this.form.labels.map(label => label.key),
        movements:
          this.form.movements.length > 0 ? this.form.movements : undefined,
        name: this.form.name,
        linkedAccountingCash: formattedLinkedAccountingCash,
      };

      try {
        await this.$store.dispatch('ACCOUNTING-CASH/OpenAsGeneral', payload);
        await this.$refs.OpenedRef.loadAccounting();
        await this.$refs.ClosedRef.ListAccountings();
        toast.success('Caixa castrada com sucesso');
      } catch (error) {
        toast.error('Não foi possível criar a caixa');
      } finally {
        this.control.createButtonIsDisabled = false;
      }
    },
    concatLinked() {
      const formattedExitent = this.existenteLinkedAccounting.map(
        linked => linked.accounting,
      );
      const concat = this.form.linkedAccountingCash.concat(formattedExitent);
      const totalSystemSales = concat.reduce(
        (acc, account) => acc + account.totalSystemSales,
        0,
      );
      const concatedLinks = concat.map(item => item._id);

      return { totalSystemSales, concatedLinks };
    },
    async enterEditMode(accounting) {
      const payload = {
        accountingCashId: accounting._id,
      };
      const { linked, openingAccounting, name } = await this.$store.dispatch(
        'ACCOUNTING-CASH/GetGeneralInfo',
        payload,
      );

      const formattedLabels = openingAccounting.labels
        ? this.existentLabels.filter(
            label =>
              openingAccounting.labels.findIndex(
                l => String(l) === String(label.key),
              ) >= 0,
          )
        : [];

      this.$refs.ClosedRef.resetSelectedAccountings();
      this.control.editModeId = accounting._id;
      this.form.name = name;
      this.form.movements = openingAccounting.movements;
      this.form.totalSystemSales = (
        accounting.openingAccounting.totalSystemSales / 100
      ).toFixed(2);
      this.form.labels = formattedLabels;
      this.existenteLinkedAccounting = linked;
    },
    disableEditMode() {
      this.control.editModeId = '';
      this.form.name = '';
      this.form.totalSystemSales = '';
      this.form.labels = [];
      this.existenteLinkedAccounting = [];
      this.form.linkedAccountingCash = [];
      this.form.movements = [];
    },
    async saveEdition() {
      this.control.createButtonIsDisabled = true;

      const { totalSystemSales, concatedLinks } = this.concatLinked();

      const payload = {
        totalSystemSales,
        accountingId: this.control.editModeId,
        labels: this.form.labels.map(label => label.key),
        movements: this.form.movements.length > 0 ? this.form.movements : [],
        name: this.form.name,
        linkedAccountingCash: concatedLinks,
      };

      try {
        await this.$store.dispatch('ACCOUNTING-CASH/OpenAsGeneral', payload);
        toast.success('Caixa castrada com sucesso');
        await this.$refs.OpenedRef.loadAccounting();
        await this.$refs.ClosedRef.ListAccountings();
        this.disableEditMode();
      } catch (error) {
        toast.error('Não foi possível criar a caixa');
      } finally {
        this.control.createButtonIsDisabled = false;
      }
    },
  },
};
</script>